import type { WidgetType } from "../widgets";
import addonChangesForm from "./addon_changes";
import addonEditForm from "./addon_edit";
import addonCreateForm from "./addon_single";
import customForm from "./custom";
import mfaqFollowUpForm from "./mfaq_followup";
import plannedForm from "./planned";
import productIssueForm from "./product_issue";
import productQualityForm from "./product_quality";
import roomsettingsForm from "./roomsettings_edit";

import type { ReactNode } from "react";

type TaskFormCallback<Result> = (...args: any[]) => Result;

type TaskFormHeader = {
  newTitle: ReactNode;
  editTitle: ReactNode | TaskFormCallback<ReactNode>;
  alwaysSticky?: boolean;
  hideTallHeader?: boolean;
  testId?: string;
};

type TaskFormField = {
  type: WidgetType;
  disabled?: boolean | TaskFormCallback<boolean | (() => boolean)>;
  hide?: TaskFormCallback<boolean>;
  values?: {
    in?: TaskFormCallback<unknown>;
    out?: TaskFormCallback<unknown>;
  };
  conf?: Record<string, unknown>;
};

export type TaskFormTypes = {
  header: TaskFormHeader;
  fields: TaskFormField[];
  useReactToChanges?: (...args: unknown[]) => unknown;
};

export type TaskFormTypeNamesType =
  | "product"
  | "custom"
  | "planned"
  | "product_quality"
  | "mfaq_followup"
  | "addon_edit"
  | "addon_changes"
  | "addon_create"
  | "roomsettings_edit";

// Legacy JavaScript configs widen widget literals to strings before reaching this typed registry.
const TaskTypes = {
  product: productIssueForm,
  addon_edit: addonEditForm,
  addon_changes: addonChangesForm,
  addon_create: addonCreateForm,
  custom: customForm,
  planned: plannedForm,
  product_quality: productQualityForm,
  mfaq_followup: mfaqFollowUpForm,
  roomsettings_edit: roomsettingsForm,
} as unknown as Record<TaskFormTypeNamesType, TaskFormTypes>;

export default TaskTypes;
